module.exports = __webpack_public_path__ + "static/img/图层 19.d9010112.png";